/**
 * product-description-toggle.js
 * ---------------------------------------------------------------------------
 * Botão "Ver mais" da descrição padrão da PDP — expande/recolhe o texto
 * (truncado em 3 linhas via CSS line-clamp). Sem dependências.
 * ---------------------------------------------------------------------------
 */
document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-product-description-toggle]');
  if (!toggle) return;

  const wrap = toggle.closest('.product__description-wrap');
  if (!wrap) return;

  const description = wrap.querySelector('.product__description');
  if (!description) return;

  const isCollapsed = description.classList.toggle('product__description--collapsed');
  toggle.textContent = isCollapsed
    ? toggle.dataset.readMoreLabel || 'Ver mais'
    : toggle.dataset.readLessLabel || 'Ver menos';
});